import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-3.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	attendStyle,
	titleStyle,
	attendTitleStyle,
	textStyle,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

const MedicareForMeStep4Page = () => (
  <div className={wrapperStyle}>

    <section className={contentSection()} id="level-3">
      <div className={innerWrapperStyle}>
        <header>
          <h1 className={titleStyle}>Get assessed by a paediatrician or psychiatrist AND visit your GP</h1>
        </header>
        <div className={textStyle}>
          <p>To access the final 20 rebated psychological sessions, you need to again visit your GP for another review. Prior this review your GP will need a written report from a psychiatrist or paediatrician who has assessed you.</p>
          <p>TIP: It is very helpful for your psychologist or mental health practitioner to provide a report to the psychiatrist or paediatrician (and a copy to your GP) before you see them. Your psychologist will have a good understanding of the need for further treatment sessions. We have templates for these psychological reports on our website.</p>

          <p>The psychiatrist or paediatrician needs to confirm your diagnosis, evaluate your response to therapy so far and make a recommendation as to whether further sessions are needed. If at this point you no longer meet the intake criteria because you are improving, this alone does not affect your eligibility for a further 20 sessions. The psychiatrist / paediatrician only needs to confirm your diagnosis at the time of entry to the rebated sessions and your need for further sessions</p>
        </div>
      </div>
    </section>

    <section className={contentSection('#fff')}>
      <div className={attendStyle}>
        <div>
          <h1 className={attendTitleStyle}>Attend Sessions 21-30</h1>
          <div className={textStyle}></div>
        </div>
        <img src={ PersonImg } alt="" />
      </div>
    </section>
  </div>
);

export { MedicareForMeStep4Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-me/step-4.js